import { Box } from '@mui/material';
import { TournamentInvitation } from 'modules/tournaments/components/BracketTournament/TournamentInvitationList/TournamentInvitation';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

export const TournamentInvitationList: FC = () => {
  const invitations = useSelector(currentTournamentSelector.invitations);

  if (!Boolean(invitations?.length)) {
    return null;
  }

  return (
    <Box mt={1}>
      {invitations.map((invitation, index) => (
        <Box mt={1} mb={1} key={index}>
          <TournamentInvitation invitation={invitation} />
        </Box>
      ))}
    </Box>
  );
};
